<po-modal
  #sendModal
  p-title="Novo Review"
  [p-size]="modalSize"
  [class.sr-modal-compact]="isCompactStep"
  [p-primary-action]="confirmAction"
  [p-secondary-action]="cancelAction"
  p-click-out="false">

  <!-- ══════════════════════════════════════════════════════
       PASSO 0 — De onde vem o código
       O que existe hoje passa a ser o ramo TFVC, sem mudança de comportamento.
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'origin-select'" data-step="origin-select" class="sr-options-grid">

    <po-widget
      class="sr-option-widget"
      [class.sr-option-disabled]="!originAvailability.tfvc"
      p-no-shadow="true"
      (p-click)="selectOrigin('tfvc')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-database"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">TFVC</div>
          <div class="sr-option-desc" *ngIf="originAvailability.tfvc">
            Changeset, comparação ou issue do Jira
          </div>
          <div class="sr-option-desc" *ngIf="!originAvailability.tfvc">
            {{ tfvcUnavailableReason || 'Indisponível neste ambiente' }}
          </div>
        </div>
      </div>
    </po-widget>

    <!-- Provedor sem navegação por usuário não é oferecido: um caminho que falha no
         clique é pior que um caminho que não aparece. -->
    <po-widget
      class="sr-option-widget"
      [class.sr-option-disabled]="!originAvailability.git"
      p-no-shadow="true"
      (p-click)="selectOrigin('git')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-share"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Git</div>
          <div class="sr-option-desc" *ngIf="originAvailability.git">
            Pull Request, commit ou Git Comparison
          </div>
          <div class="sr-option-desc" *ngIf="!originAvailability.git">
            {{ gitUnavailableReason || 'Indisponível neste ambiente' }}
          </div>
        </div>
      </div>
    </po-widget>

    <!-- Standalone é ORIGEM, não um tipo dentro do TFVC: o conteúdo vem da máquina de quem
         pede, e não há repositório de lado nenhum. Enquanto ele morava no ramo TFVC, quem
         só trabalha em repositório git não tinha caminho até ele — e o backend concordava,
         respondendo 403 (ver o registro de decisão 0007).
         O nome é o mesmo que o grid, o filtro de tipo e a curadoria já usam. -->
    <po-widget
      class="sr-option-widget"
      p-no-shadow="true"
      (p-click)="selectOrigin('standalone')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-document"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Standalone</div>
          <div class="sr-option-desc">
            Enviar um arquivo do seu computador para análise isolada
          </div>
        </div>
      </div>
    </po-widget>

  </div>

  <!-- ══════════════════════════════════════════════════════
       PASSO 2 (git) — O que revisar no repositório
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'git-type-select'" data-step="git-type-select" class="sr-options-grid">

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectGitType('pull')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-share"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Pull Request</div>
          <div class="sr-option-desc">Revisar as mudanças de um Pull Request aberto</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectGitType('commit')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-history"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Commit</div>
          <div class="sr-option-desc">Revisar as mudanças de um commit — o equivalente ao changeset do TFVC</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectGitType('comparison')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-change"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Git Comparison</div>
          <div class="sr-option-desc">Escolha entre arquivo local, commit de origem e commit de destino</div>
        </div>
      </div>
    </po-widget>

  </div>

  <!-- ══════════════════════════════════════════════════════
       GIT — Sub-tipo de comparison
       (mesma UX do TFVC: escolhe o modo antes dos dados)
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'git-comparison-select'" data-step="git-comparison-select" class="sr-options-grid">

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectGitComparisonSubType('commitVsFile')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-document-double"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Commit de origem × arquivo local</div>
          <div class="sr-option-desc">Origem no Git + arquivo local do workspace</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectGitComparisonSubType('commitVsCommit')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-history"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Commit de origem × commit de destino</div>
          <div class="sr-option-desc">Selecione origem e destino no histórico Git</div>
        </div>
      </div>
    </po-widget>

  </div>


  <!-- ══════════════════════════════════════════════════════
       GIT — repositório cadastrado para review
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'git-repo-select'" data-step="git-repo-select" class="sr-git-step">
    <po-combo
      *ngIf="!hasNoRegisteredRepos"
      name="gitRepo"
      p-label="Repositório"
      p-placeholder="Digite o nome, dono/nome ou o provedor"
      p-help="Mostra somente repositórios cadastrados, habilitados e acessíveis para você no provedor Git."
      p-clean="true"
      [p-filter-service]="gitRepoComboFilterService"
      [p-debounce-time]="400"
      [ngModel]="gitRepoValue"
      (ngModelChange)="onGitRepoSelected($event)">
    </po-combo>

    <!-- A lista vem cortada pelo servidor porque cada repositório custa uma consulta de
         permissão ao provedor. Dizer isso evita que quem não achar o seu conclua que não
         tem acesso, quando bastava digitar o nome. -->
    <div *ngIf="showsGitRepoSearchHint" class="sr-git-message" data-hint="git-repo-truncated">
      Mostrando os primeiros resultados. Digite o nome, o dono/nome ou o provedor para
      encontrar um repositório que não esteja na lista.
    </div>

    <!-- Nenhum cadastro não é erro: é o estado inicial de toda instalação. A tela diz o
         que falta e onde se resolve, em vez de deixar um campo vazio sem explicação. -->
    <div *ngIf="hasNoRegisteredRepos" class="sr-git-empty" data-empty="git-repo-select">
      <span class="po-icon po-icon-folder"></span>
      <div>
        <strong>Nenhum repositório cadastrado neste provedor.</strong>
        <p>
          O review só é aceito em repositório cadastrado — é assim que se decide o que a
          ferramenta revisa. Peça a um administrador para cadastrá-lo em
          <em>Administração &gt; Repositórios</em>.
        </p>
      </div>
    </div>

    <div *ngIf="gitListError" class="sr-git-message">{{ gitListError }}</div>
  </div>

  <!-- ══════════════════════════════════════════════════════
       GIT — pull request
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'git-pull-select'" data-step="git-pull-select" class="sr-git-step">
    <div class="sr-git-repo-header" *ngIf="selectedGitRepo">
      <span class="po-icon po-icon-folder"></span>
      <strong>{{ selectedGitRepo.fullName }}</strong>
    </div>

    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyPull' }">
    </ng-container>

    <po-divider p-label="Pull requests"></po-divider>

    <div class="po-row">
      <po-select
        class="po-md-4 sr-git-filter"
        name="gitPullState"
        p-label="Situação"
        [p-options]="[
          { label: 'Abertos', value: 'open' },
          { label: 'Fechados', value: 'closed' },
          { label: 'Todos', value: 'all' }
        ]"
        [ngModel]="gitPullState"
        (p-change)="onGitPullStateChange($event)">
      </po-select>
      <!-- Abre na branch padrão do cadastro, quando ela existe no provedor: é para onde os
           Pull Requests do repositório vão. O recorte é no backend, não sobre a lista. -->
      <po-select
        *ngIf="!loadingGitBranches"
        class="po-md-4 sr-git-filter"
        name="gitPullTargetBranch"
        p-label="Branch de destino"
        [p-options]="gitBranchOptions"
        [ngModel]="gitPullTargetBranch"
        (p-change)="onGitPullTargetBranchChange($event)">
      </po-select>
    </div>

    <ng-container *ngIf="loadingGitBranches || loadingGitPulls" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Carregando pull requests' }"></ng-container>

    <div *ngIf="!loadingGitBranches && !loadingGitPulls && gitListError" class="sr-git-message">{{ gitListError }}</div>

    <div *ngIf="!loadingGitBranches && !loadingGitPulls && !gitListError && gitPullRows.length === 0" class="sr-git-message">
      Nenhum pull request neste filtro.
    </div>

    <po-table
      *ngIf="!loadingGitBranches && !loadingGitPulls && gitPullRows.length > 0"
      class="sr-git-table"
      [p-columns]="gitPullColumns"
      [p-items]="gitPullRows"
      [p-height]="gitPullTableHeight"
      [p-selectable]="true"
      [p-single-select]="true"
      [p-selectable-entire-line]="true"
      [p-hide-select-all]="true"
      [p-hide-columns-manager]="true"
      [p-hide-table-search]="false"
      [p-filter-type]="tableSearchFilterType"
      p-spacing="small"
      (p-selected)="onGitPullRowSelected($event)"
      (p-unselected)="onGitPullRowUnselected()">
    </po-table>

    <div class="sr-git-selected" *ngIf="selectedGitPull">
      Selecionado: <strong>#{{ selectedGitPull.number }} — {{ selectedGitPull.title }}</strong>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════
       GIT — commit
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'git-commit-select'" data-step="git-commit-select" class="sr-git-step">
    <div class="sr-git-repo-header" *ngIf="selectedGitRepo">
      <span class="po-icon po-icon-folder"></span>
      <strong>{{ selectedGitRepo.fullName }}</strong>
    </div>

    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyCommit' }">
    </ng-container>

    <po-divider p-label="Branch"></po-divider>

    <ng-container *ngIf="loadingGitBranches" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Carregando branches' }"></ng-container>

    <div class="po-row" *ngIf="!loadingGitBranches && gitBranchOptions.length > 0">
      <po-select
        class="po-md-4 sr-git-filter"
        name="gitBranch"
        p-label="Branch"
        [p-options]="gitBranchOptions"
        [ngModel]="selectedGitBranch"
        (p-change)="onGitBranchChange($event)">
      </po-select>
    </div>

    <po-divider p-label="Commits"></po-divider>

    <ng-container *ngIf="loadingGitCommits" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Carregando commits' }"></ng-container>

    <div *ngIf="!loadingGitCommits && gitListError" class="sr-git-message">{{ gitListError }}</div>

    <!-- Sem branch nenhuma o select nem aparece, então "nesta branch" apontaria para uma
         escolha que nunca foi oferecida. Os dois vazios são causas diferentes. -->
    <div *ngIf="!loadingGitBranches && !loadingGitCommits && !gitListError && gitCommitRows.length === 0"
         class="sr-git-message">
      {{ gitBranchOptions.length === 0 ? 'Este repositório não tem branches.' : 'Nenhum commit nesta branch.' }}
    </div>

    <po-table
      *ngIf="!loadingGitCommits && gitCommitRows.length > 0"
      class="sr-git-table"
      [p-columns]="gitCommitColumns"
      [p-items]="gitCommitRows"
      [p-height]="gitCommitTableHeight"
      [p-selectable]="true"
      [p-single-select]="true"
      [p-selectable-entire-line]="true"
      [p-hide-select-all]="true"
      [p-hide-columns-manager]="true"
      [p-hide-table-search]="false"
      [p-filter-type]="tableSearchFilterType"
      p-spacing="small"
      (p-selected)="onGitCommitRowSelected($event)"
      (p-unselected)="onGitCommitRowUnselected()">
    </po-table>

    <div class="sr-git-selected" *ngIf="selectedGitCommit">
      Selecionado: <strong>{{ selectedGitCommit.shortRevision }} — {{ selectedGitCommit.subject }}</strong>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════
       GIT — Git Comparison
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'git-comparison-form'">
    <div data-step="git-comparison-form" hidden></div>

    <div class="sr-git-step sr-git-comparison-step">
      <div class="sr-git-repo-header" *ngIf="selectedGitRepo">
        <span class="po-icon po-icon-folder"></span>
        <strong>{{ selectedGitRepo.fullName }}</strong>
      </div>

      <ng-container
        [ngTemplateOutlet]="issueContextField"
        [ngTemplateOutletContext]="{ name: 'issueKeyComparison' }">
      </ng-container>

      <ng-container *ngIf="gitComparisonMode === 'commitVsFile'">
        <po-divider p-label="1. Arquivo local"></po-divider>
        <div class="po-row po-mt-1">
          <input #gitLocalFileInput type="file" style="display:none"
            (change)="onLocalFileChange($event)">
          <po-button
            class="po-md-8"
            [p-label]="localFileName || 'Selecionar arquivo local'"
            p-kind="secondary"
            p-icon="po-icon-upload"
            (p-click)="gitLocalFileInput.click()">
          </po-button>
        </div>
      </ng-container>

      <ng-container *ngIf="gitComparisonMode === 'commitVsCommit' || localFileName">
        <po-divider [p-label]="gitComparisonMode === 'commitVsFile' ? '2. Arquivo no repositório' : '1. Arquivo no repositório'"></po-divider>

        <div class="po-row">
          <!-- A branch vem primeiro porque é ela que define ONDE procurar: a busca do fonte
               é por branch. Com o arquivo à frente, quem digitasse o nome estaria buscando
               na padrão sem saber, e um fonte que só existe na branch de trabalho não
               apareceria — indistinguível, na tela, de o arquivo não existir. -->
          <po-select
            *ngIf="!loadingGitBranches"
            class="po-md-4"
            name="gitComparisonRef"
            p-label="Branch"
            [p-options]="gitBranchOptions"
            [ngModel]="gitComparisonRef"
            (p-change)="onGitComparisonRefChange($event)">
          </po-select>
          <!-- Busca por NOME, sem diferenciar maiúsculas: quem pede o review sabe o nome do
               fonte, não o diretório. O valor escolhido é o caminho exato do repositório,
               que é o que segue para o histórico e para o review. -->
          <po-combo
            class="po-md-8"
            name="gitComparisonPath"
            p-label="Arquivo no repositório"
            p-placeholder="Digite o nome do fonte, ex.: CRMA010"
            p-filter-mode="contains"
            [p-filter-service]="gitFileComboFilterService"
            [p-debounce-time]="400"
            [ngModel]="gitComparisonPath"
            (ngModelChange)="onGitComparisonPathChange($event)">
          </po-combo>
        </div>

        <ng-container *ngIf="loadingGitBranches" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Carregando branches' }"></ng-container>

        <div class="po-row po-mt-2">
          <div class="po-md-12">
            <po-button
              p-label="Buscar histórico"
              p-kind="secondary"
              p-icon="po-icon-search"
              [p-disabled]="loadingGitFileHistory || !gitComparisonPath.trim()"
              (p-click)="loadGitFileHistory()">
            </po-button>
          </div>
        </div>

        <ng-container *ngIf="loadingGitFileAutoMatch" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Procurando ' + localFileName + ' no repositório' }"></ng-container>
        <div *ngIf="!loadingGitFileAutoMatch && gitFileAutoMatchHint" class="sr-git-message">{{ gitFileAutoMatchHint }}</div>

        <ng-container *ngIf="loadingGitFileHistory" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Carregando histórico do arquivo' }"></ng-container>

        <div *ngIf="!loadingGitFileHistory && gitListError" class="sr-git-message">{{ gitListError }}</div>

        <po-table
          *ngIf="gitComparisonMode === 'commitVsFile' && !loadingGitFileHistory && gitBaseRevisionRows.length > 0"
          class="sr-git-table"
          [p-columns]="gitRevisionColumns"
          [p-items]="gitBaseRevisionRows"
          [p-height]="gitRevisionTableHeight"
          [p-selectable]="true"
          [p-single-select]="true"
          [p-selectable-entire-line]="true"
          [p-hide-select-all]="true"
          [p-hide-columns-manager]="true"
          [p-hide-table-search]="false"
          [p-filter-type]="tableSearchFilterType"
          p-spacing="small"
          (p-selected)="onGitBaseRevisionRowSelected($event)"
          (p-unselected)="onGitBaseRevisionRowUnselected()">
        </po-table>

        <ng-container *ngIf="gitComparisonMode === 'commitVsCommit' && !loadingGitFileHistory && gitRevisionHistory.length > 0">
          <po-divider p-label="2. Commits"></po-divider>

          <div class="sr-git-revision-role"><span class="po-icon po-icon-arrow-left"></span> Origem · Versão base</div>
          <po-table
            class="sr-git-table"
            [p-columns]="gitRevisionColumns"
            [p-items]="gitFromRevisionRows"
            [p-height]="gitRevisionTableHeight"
            [p-selectable]="true"
            [p-single-select]="true"
            [p-selectable-entire-line]="true"
            [p-hide-select-all]="true"
            [p-hide-columns-manager]="true"
            [p-hide-table-search]="false"
            [p-filter-type]="tableSearchFilterType"
            p-spacing="small"
            (p-selected)="onGitFromRevisionRowSelected($event)"
            (p-unselected)="onGitFromRevisionRowUnselected()">
          </po-table>

          <div class="sr-git-revision-role"><span class="po-icon po-icon-arrow-right"></span> Destino · Versão alvo</div>
          <po-table
            class="sr-git-table"
            [p-columns]="gitRevisionColumns"
            [p-items]="gitToRevisionRows"
            [p-height]="gitRevisionTableHeight"
            [p-selectable]="true"
            [p-single-select]="true"
            [p-selectable-entire-line]="true"
            [p-hide-select-all]="true"
            [p-hide-columns-manager]="true"
            [p-hide-table-search]="false"
            [p-filter-type]="tableSearchFilterType"
            p-spacing="small"
            (p-selected)="onGitToRevisionRowSelected($event)"
            (p-unselected)="onGitToRevisionRowUnselected()">
          </po-table>

          <div *ngIf="hasSameGitComparisonRevisions" class="sr-git-message">
            Origem e destino precisam ser commits diferentes.
          </div>
        </ng-container>

        <div class="sr-git-selected" *ngIf="gitComparisonMode === 'commitVsFile' && selectedGitBaseRevision">
          Base selecionada: <strong>{{ selectedGitBaseRevision.shortRevision || selectedGitBaseRevision.revision }}</strong>
        </div>
      </ng-container>

      <ng-container *ngIf="confirmationSummary">
        <po-divider p-label="Resumo"></po-divider>
        <div class="sr-confirm-block">
          <div class="sr-confirm-row">
            <span class="sr-confirm-label">Arquivo:</span> {{ confirmationSummary.fileName }}
          </div>
          <div class="sr-confirm-row">
            <span class="sr-confirm-label">Git:</span> {{ confirmationSummary.pathInfo }}
          </div>
          <div class="sr-confirm-row">
            <span class="sr-confirm-label">Revisão:</span> {{ confirmationSummary.changesetInfo }}
          </div>
          <div class="sr-confirm-row" *ngIf="confirmationSummary.issueInfo">
            <span class="sr-confirm-label">Issue:</span> {{ confirmationSummary.issueInfo }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- ══════════════════════════════════════════════════════
       PASSO 1 — Escolha o tipo de review
       (igual VS Code: showQuickPick com 3 opções)
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'type-select'" data-step="type-select" class="sr-options-grid">

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectMainType('comparison')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-change"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">TFVC Comparison</div>
          <div class="sr-option-desc">Escolha entre arquivo local, changeset de origem e changeset de destino</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectMainType('issue')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-clipboard"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Issue (Jira)</div>
          <div class="sr-option-desc">Solicitar review para uma issue do Jira</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectMainType('changeset')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-layers"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Changeset</div>
          <div class="sr-option-desc">Solicitar review completo de um changeset pelo ID</div>
        </div>
      </div>
    </po-widget>

  </div>

  <!-- ══════════════════════════════════════════════════════
       PASSO 2 — Sub-tipo de comparação
       (igual VS Code: showQuickPick com 2 opções)
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'comparison-select'" data-step="comparison-select" class="sr-options-grid">

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectComparisonSubType('tfvcVsFile')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-document-double"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Changeset de origem × arquivo local</div>
          <div class="sr-option-desc">Origem no TFVC + arquivo local do workspace</div>
        </div>
      </div>
    </po-widget>

    <po-widget class="sr-option-widget" p-no-shadow="true" (p-click)="selectComparisonSubType('tfvcVsTfvc')">
      <div class="sr-option-content">
        <div class="sr-option-icon"><span class="po-icon po-icon-history"></span></div>
        <div class="sr-option-body">
          <div class="sr-option-title">Changeset de origem × changeset de destino</div>
          <div class="sr-option-desc">Selecione origem e destino no histórico TFVC</div>
        </div>
      </div>
    </po-widget>

  </div>

  <!-- ══════════════════════════════════════════════════════
       COMPARISON: arquivo local vs TFVC
       Arquivo primeiro → auto-busca TFVC → changeset → resumo
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'comparison-file-form'">
    <!-- Marcador do passo. Ver send-review-modal.template.spec.ts: é por ele que
         o teste afirma que o passo tem bloco no template. -->
    <div data-step="comparison-file-form" hidden></div>

    <!-- Passo A: Arquivo local -->
    <po-divider p-label="1. Arquivo local (versão nova)"></po-divider>
    <div class="po-row po-mt-1">
      <input #localFileInputComp type="file" style="display:none"
        (change)="onLocalFileChange($event)">
      <po-button
        class="po-md-8"
        [p-label]="localFileName || 'Selecionar arquivo local'"
        p-kind="secondary"
        p-icon="po-icon-upload"
        (p-click)="localFileInputComp.click()">
      </po-button>
    </div>

    <!-- Passo B: TFVC — aparece após arquivo válido selecionado -->
    <ng-container *ngIf="localFileName">
      <po-divider p-label="2. Localizar referência no TFVC"></po-divider>
      <div class="po-row">
        <po-input
          class="po-md-9"
          name="tfvcQuery"
          p-label="Buscar arquivo TFVC"
          p-placeholder="Ex: MATA030"
          [p-disabled]="loadingTfvcSearch"
          [(ngModel)]="tfvcQuery"
          (keyup.enter)="searchTfvcFiles()">
        </po-input>
        <div class="po-md-3 po-mt-4">
          <po-button p-label="Buscar" p-kind="secondary" p-icon="po-icon-search"
            [p-disabled]="loadingTfvcSearch || !tfvcQuery.trim()"
            (p-click)="searchTfvcFiles()">
          </po-button>
        </div>
      </div>
      <ng-container *ngIf="loadingTfvcSearch" [ngTemplateOutlet]="stepLoading"
        [ngTemplateOutletContext]="{ $implicit: 'Buscando fontes no TFVC...' }"></ng-container>
      <div class="po-row" *ngIf="tfvcFileOptions.length > 0">
        <po-select
          class="po-md-12"
          name="tfvcFileSel"
          p-label="Arquivo TFVC"
          [p-options]="tfvcFileOptions"
          [(ngModel)]="selectedTfvcPath"
          (p-change)="onTfvcFileSelect($event)">
        </po-select>
      </div>
      <div class="po-row" *ngIf="tfvcFileNameMismatch">
        <div class="po-md-12 sr-alert-tag" role="alert">
          <po-tag p-type="warning" [p-icon]="true" [p-value]="tfvcMismatchMessage"></po-tag>
        </div>
      </div>
    </ng-container>

    <!-- Passo C: Changeset de origem — aparece após TFVC selecionado -->
    <ng-container *ngIf="selectedTfvcPath && !loadingHistory && changesets.length > 0">
      <po-divider p-label="3. Changeset de referência (origem)"></po-divider>
      <app-changeset-table
        iconClass="po-icon po-icon-arrow-left"
        label="Origem · Versão base"
        [items]="fromChangesetItems"
        [columns]="changesetColumns"
        [showMore]="true"
        [hasMoreHistory]="hasMoreHistory"
        [loadingMoreHistory]="loadingMoreHistory"
        (selected)="onFromChangesetSelected($event)"
        (unselected)="onFromChangesetUnselected($event)"
        (showMoreClick)="loadMoreHistory()">
      </app-changeset-table>
    </ng-container>
    <div class="po-row" *ngIf="loadingHistory">
      <po-loading-overlay></po-loading-overlay>
    </div>
    <div class="po-row" *ngIf="historyLoadError && !loadingHistory">
      <div class="po-md-12 sr-alert-tag" role="alert">
        <po-tag p-type="danger" [p-icon]="true" [p-value]="historyLoadError"></po-tag>
      </div>
    </div>

    <!-- Resumo (igual VS Code: QuickPick "Confirmar envio") -->
    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyComparisonFile' }">
    </ng-container>

    <ng-container *ngIf="confirmationSummary">
      <po-divider p-label="Resumo"></po-divider>
      <div class="sr-confirm-block">
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Arquivo:</span> {{ confirmationSummary.fileName }}
        </div>
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">TFVC:</span> {{ confirmationSummary.pathInfo }}
        </div>
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Changeset:</span> {{ confirmationSummary.changesetInfo }}
        </div>
      </div>
    </ng-container>

  </ng-container>

  <!-- ══════════════════════════════════════════════════════
       COMPARISON: TFVC vs TFVC
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'comparison-tfvc-form'">
    <!-- Marcador do passo. Ver send-review-modal.template.spec.ts: é por ele que
         o teste afirma que o passo tem bloco no template. -->
    <div data-step="comparison-tfvc-form" hidden></div>

    <po-divider p-label="1. Localizar arquivo no TFVC"></po-divider>
    <div class="po-row">
      <po-input
        class="po-md-9"
        name="tfvcQuery2"
        p-label="Buscar arquivo TFVC"
        p-placeholder="Ex: MATA030 ou $/Projeto/src/MATA030.prw"
        [p-disabled]="loadingTfvcSearch"
        [(ngModel)]="tfvcQuery"
        (keyup.enter)="searchTfvcFiles()">
      </po-input>
      <div class="po-md-3 po-mt-4">
        <po-button p-label="Buscar" p-kind="secondary" p-icon="po-icon-search"
          [p-disabled]="loadingTfvcSearch || !tfvcQuery.trim()"
          (p-click)="searchTfvcFiles()">
        </po-button>
      </div>
    </div>
    <ng-container *ngIf="loadingTfvcSearch" [ngTemplateOutlet]="stepLoading"
      [ngTemplateOutletContext]="{ $implicit: 'Buscando fontes no TFVC...' }"></ng-container>
    <div class="po-row" *ngIf="tfvcFileOptions.length > 0">
      <po-select
        class="po-md-12"
        name="tfvcFileSel2"
        p-label="Arquivo TFVC"
        [p-options]="tfvcFileOptions"
        [(ngModel)]="selectedTfvcPath"
        (p-change)="onTfvcFileSelect($event)">
      </po-select>
    </div>
    <div class="po-row" *ngIf="loadingHistory">
      <po-loading-overlay></po-loading-overlay>
    </div>

    <!-- Origem e Destino — aparecem juntos após TFVC selecionado -->
    <ng-container *ngIf="selectedTfvcPath && changesets.length > 0 && !loadingHistory">
      <po-divider p-label="2. Changesets"></po-divider>
      <app-changeset-table
        iconClass="po-icon po-icon-arrow-left"
        label="Origem · Versão base"
        [items]="fromChangesetItems"
        [columns]="changesetColumns"
        [showMore]="false"
        (selected)="onFromChangesetSelected($event)"
        (unselected)="onFromChangesetUnselected($event)">
      </app-changeset-table>
      <app-changeset-table
        iconClass="po-icon po-icon-arrow-right"
        label="Destino · Versão alvo"
        [items]="toChangesetItems"
        [columns]="changesetColumns"
        [showMore]="true"
        [hasMoreHistory]="hasMoreHistory"
        [loadingMoreHistory]="loadingMoreHistory"
        (selected)="onToChangesetSelected($event)"
        (unselected)="onToChangesetUnselected($event)"
        (showMoreClick)="loadMoreHistory()">
      </app-changeset-table>
    </ng-container>
    <div class="po-row" *ngIf="historyLoadError && !loadingHistory">
      <div class="po-md-12 sr-alert-tag" role="alert">
        <po-tag p-type="danger" [p-icon]="true" [p-value]="historyLoadError"></po-tag>
      </div>
    </div>

    <!-- Resumo -->
    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyComparisonTfvc' }">
    </ng-container>

    <ng-container *ngIf="confirmationSummary">
      <po-divider p-label="Resumo"></po-divider>
      <div class="sr-confirm-block">
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">TFVC:</span> {{ confirmationSummary.pathInfo }}
        </div>
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Changeset:</span> {{ confirmationSummary.changesetInfo }}
        </div>
      </div>
    </ng-container>

  </ng-container>

  <!-- ══════════════════════════════════════════════════════
       STANDALONE
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'standalone-form'">
    <!-- Marcador do passo. Ver send-review-modal.template.spec.ts: é por ele que
         o teste afirma que o passo tem bloco no template. -->
    <div data-step="standalone-form" hidden></div>

    <po-divider p-label="Arquivo para análise isolada"></po-divider>
    <div class="po-row po-mt-1">
      <input #standaloneFileInput type="file" style="display:none"
        (change)="onLocalFileChange($event)">
      <po-button
        class="po-md-8"
        [p-label]="localFileName || 'Selecionar arquivo'"
        p-kind="secondary"
        p-icon="po-icon-upload"
        (p-click)="standaloneFileInput.click()">
      </po-button>
    </div>

    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyStandalone' }">
    </ng-container>

    <ng-container *ngIf="confirmationSummary">
      <po-divider p-label="Resumo"></po-divider>
      <div class="sr-confirm-block">
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Arquivo:</span> {{ confirmationSummary.fileName }}
        </div>
      </div>
    </ng-container>

  </ng-container>

  <!-- ══════════════════════════════════════════════════════
       ISSUE JIRA
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'issue-form'">
    <!-- Marcador do passo. Ver send-review-modal.template.spec.ts: é por ele que
         o teste afirma que o passo tem bloco no template. -->
    <div data-step="issue-form" hidden></div>

    <po-divider p-label="Issue do Jira"></po-divider>

    <div class="po-row po-mt-1">
      <po-radio-group
        class="po-md-12"
        name="issueInputMode"
        p-label="Forma de preenchimento"
        [p-options]="issueInputModeOptions"
        [(ngModel)]="issueInputMode"
        (ngModelChange)="onIssueInputModeChange($event)">
      </po-radio-group>
    </div>

    <div class="po-row po-mt-1" *ngIf="issueInputMode === 'select'">
      <po-combo
        class="po-md-12"
        name="issueKey"
        p-label="Selecione uma issue recente"
        p-help="Mostrando as 50 issues mais recentes associadas ao seu usuário."
        p-placeholder="Selecione uma issue recente"
        p-clean="true"
        [p-filter-service]="jiraIssueComboFilterService"
        [p-filter-minlength]="issueComboFilterMinLength"
        [(ngModel)]="issueKey"
        (keydown)="onIssueSelectKeyDown($event)"
        (paste)="onIssueSelectPaste($event)"
        (ngModelChange)="onIssueKeyChange($event)">
      </po-combo>
      <div *ngIf="issueListError" class="po-md-12 sr-git-message">{{ issueListError }}</div>
    </div>

    <div class="po-row po-mt-1" *ngIf="issueInputMode === 'type'">
      <po-input
        class="po-md-6"
        name="issueKeyTyped"
        p-label="Digite a chave da issue"
        p-help="Informe apenas a chave (ex: PROJ-1234)."
        p-placeholder="Ex: PROJ-1234"
        p-clean="true"
        [(ngModel)]="issueKeyTyped"
        (ngModelChange)="onIssueKeyTypedChange($event)">
      </po-input>
    </div>

    <!-- Resumo -->
    <ng-container *ngIf="confirmationSummary">
      <po-divider p-label="Resumo"></po-divider>
      <div class="sr-confirm-block">
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Issue:</span> {{ confirmationSummary.fileName }}
        </div>
      </div>
    </ng-container>

  </ng-container>

  <!-- ══════════════════════════════════════════════════════
       CHANGESET
       Simples: apenas o ID do changeset (número)
  ═══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="currentStep === 'changeset-form'">
    <!-- Marcador do passo. Ver send-review-modal.template.spec.ts: é por ele que
         o teste afirma que o passo tem bloco no template. -->
    <div data-step="changeset-form" hidden></div>

    <po-divider p-label="ID do Changeset"></po-divider>
    <div class="po-row po-mt-1">
      <po-input
        class="po-md-6"
        name="changesetIdInput"
        p-label="Changeset ID"
        p-placeholder="Ex: 123456"
        [(ngModel)]="changesetIdInput"
        (ngModelChange)="onChangesetIdChange($event)"
        (keyup.enter)="submit()">
      </po-input>
    </div>

    <ng-container
      [ngTemplateOutlet]="issueContextField"
      [ngTemplateOutletContext]="{ name: 'issueKeyChangeset' }">
    </ng-container>

    <ng-container *ngIf="confirmationSummary">
      <po-divider p-label="Resumo"></po-divider>
      <div class="sr-confirm-block">
        <div class="sr-confirm-row">
          <span class="sr-confirm-label">Review:</span> {{ confirmationSummary.fileName }}
        </div>
      </div>
    </ng-container>

  </ng-container>

  <div *ngIf="submitting">
    <po-loading-overlay [p-text]="submittingText"></po-loading-overlay>
  </div>
  <div *ngIf="loadingDetail" class="sr-detail-loading">
    <po-loading></po-loading>
  </div>


</po-modal>

<ng-template #issueContextField let-inputName="name">
  <po-divider p-label="Contexto Jira"></po-divider>
  <div class="po-row">
    <po-input
      class="po-md-6"
      [name]="inputName"
      p-label="Issue Jira (opcional)"
      p-placeholder="Ex: PROJ-1234"
      p-clean="true"
      [ngModel]="contextIssueKey"
      (ngModelChange)="onContextIssueKeyChange($event)">
    </po-input>
  </div>
</ng-template>

<po-modal
  #changesetDetailModal
  p-title="Detalhes do commit"
  p-size="md"
  [p-primary-action]="changesetDetailCloseAction"
  p-click-out="true">

  <ng-container *ngIf="selectedChangesetDetail">
    <div class="sr-detail-grid">
      <div class="sr-detail-item">
        <span class="sr-detail-label">Changeset</span>
        <span class="sr-detail-value">{{ selectedChangesetDetail.id }}</span>
      </div>
      <div class="sr-detail-item">
        <span class="sr-detail-label">Data</span>
        <span class="sr-detail-value">
          {{ selectedChangesetDetail.checkInDate | date: 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>
      <div class="sr-detail-item">
        <span class="sr-detail-label">Autor</span>
        <span class="sr-detail-value">{{ selectedChangesetDetail.author || '-' }}</span>
      </div>
    </div>

    <po-divider p-label="Descrição completa"></po-divider>
    <div class="sr-detail-description">
      {{ selectedChangesetDetail.description }}
    </div>
  </ng-container>

</po-modal>

<!-- ══════════════════════════════════════════════════════
     Carregando — uma definição para o modal inteiro
     ═══════════════════════════════════════════════════════
     O ramo TFVC mostrava mensagem com ícone girando mais overlay; o git usava um
     po-loading inline. Mesmo modal, duas linguagens visuais. Com uma definição só,
     acrescentar um passo novo não recria a divergência. -->
<ng-template #stepLoading let-text>
  <div class="po-row">
    <div class="po-md-12 sr-loading-msg">
      <span class="po-icon po-icon-clock"></span> {{ text }}
    </div>
  </div>
  <div class="po-row">
    <po-loading-overlay></po-loading-overlay>
  </div>
</ng-template>
